import React from "react";
import VerifyEmailId from "@techsoftware/happay-widgets/VerifyEmailId";
import history from "helper/history";
//---------------- End External Library Import --------------------//

//------------------- Start Actions Dependency Import-------------------------------------//
import * as LoginAction from "../../actions/loginaction";
//------------------- End Actions Dependency Import -------------------------------------//

//------------------- Start Helpers Dependency Import -------------------------------------//
import i18n from "../../i18nNext";
//------------------- End Helpers Dependency Import -------------------------------------//

import Common from "../../constants/common";
import HDFCLogo from "../../../public/assets/images/bank/HDFC_Bank_Logo.svg";

export default class verifyEmailId extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loader: true,
            success: false,
            msg: ""
        };
        this.successCB = this.successCB.bind(this);
        this.failCB = this.failCB.bind(this);
    }
    componentDidMount() {
        const { token = "" } = this.props;
        if (!token) {
            this.onSignIn();
        } else {
            LoginAction.verifyEmailId({ token }, this.successCB, this.failCB);
        }
    }
    successCB() {
        this.setState({
            loader: false,
            success: true,
            msg: ""
        });
    }
    failCB(msg) {
        this.setState({
            loader: false,
            success: false,
            msg
        });
    }
    onSignIn = () => {
        history.replace("/login");
    };
    render() {
        const { ProductLogo, breakPoints } = this.props;
        const { success, msg, loader } = this.state;
        return (
            <VerifyEmailId
                containerClassName={`signin-container ${
                    Common._checkIfHdfcUrl() ? "hdfcPortal" : "happayPortal"
                }`}
                logo={Common._checkIfHdfcUrl() ? HDFCLogo : ProductLogo}
                breakPoints={breakPoints}
                onSignIn={this.onSignIn}
                success={success}
                errorMsg={loader === true ? "" : msg}
                errorDesc={loader === true ? "" : i18n.t("pageContent.pleaseContactYourOrg")}
                verifyEmailIdHeader={i18n.t("pageContent.yourEmailID")}
                verifyEmailIdBody={i18n.t("pageContent.logInToStart")}
                logInButtonText={i18n.t("btn.logIn")}
                loader={loader}
                verifyingText={i18n.t("pageContent.verifying")}
            />
        );
    }
}
